import React, {
  createContext,
  useContext,
  useMemo,
  useReducer,
  useState,
} from 'react';

import { incidentRoad } from '../../constants/incidents.constant';
import {
  createIncidentAPI,
  uploadPhotoComplaint,
} from '../../services/incidents/incidents.service';
import SinisterReducer, {
  FAILURE_SINISTER,
  FAILURE_UPLOAD_PHOTO,
  REQUEST_SINISTER,
  REQUEST_UPLOAD_PHOTO,
  RESET,
  SUCCESS_SINISTER,
  SUCCESS_UPLOAD_PHOTO,
  UPDATE_SINISTER_BODY,
} from './sinister.reducer';

export const SinisterDataContext = createContext<any>(null);

const initialValues = {
  success: {},
  errors: {},
  sinister_body: {},
  image_preview: [],
  loading: false,
};

const SinisterDataProvider = ({ ...props }) => {
  const [step, setStep] = useState(0);
  const [state, dispatch] = useReducer(SinisterReducer, initialValues);

  const goBack = () => {
    dispatch({
      type: UPDATE_SINISTER_BODY,
      payload: {},
    });
    // REFACTOR: 6 is constant first steps
    if (
      incidentRoad.crash[step - 6] &&
      incidentRoad.crash[step - 6]?.order === 8 &&
      state.sinister_body.crash?.involved?.documents?.length === 0
    ) {
      setStep(step - 2);
    } else {
      setStep(step - 1);
    }
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const updateSinisterBody = (body: any) => {
    dispatch({
      type: UPDATE_SINISTER_BODY,
      payload: body,
    });
  };

  const updloadPhotos = async (formData: any) => {
    dispatch({
      type: REQUEST_UPLOAD_PHOTO,
      payload: formData,
    });

    const form = new FormData();
    for (const key in formData) {
      if (Object.prototype.hasOwnProperty.call(formData, key)) {
        if (formData[key]) {
          form.append(key, formData[key]);
        }
      }
    }

    try {
      const res = await uploadPhotoComplaint(form);
      dispatch({
        type: SUCCESS_UPLOAD_PHOTO,
        payload: res.data,
      });
    } catch (err) {
      const data = {
        ...err.response?.data,
        status: err?.response?.status,
      };
      dispatch({
        type: FAILURE_UPLOAD_PHOTO,
        payload: data,
      });
    }
  };

  const createSinister = async (body: any) => {
    dispatch({
      type: REQUEST_SINISTER,
    });

    try {
      const res = await createIncidentAPI(body);
      dispatch({
        type: SUCCESS_SINISTER,
        payload: res.data,
      });
    } catch (err) {
      const data = {
        ...err.response?.data,
        status: err?.response?.status,
      };
      dispatch({
        type: FAILURE_SINISTER,
        payload: data,
      });
    }
  };

  const resetSinister = () => {
    dispatch({
      type: RESET,
    });
  };

  const sinisterDataValue = useMemo(
    () => ({
      ...state,
      step,
      setStep,
      goBack,
      nextStep,
      updateSinisterBody,
      createSinister,
      updloadPhotos,
      resetSinister,
      dispatch,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [step, state]
  );

  return <SinisterDataContext.Provider value={sinisterDataValue} {...props} />;
};

export const useSinisterDataContext = () => useContext(SinisterDataContext);

export default SinisterDataProvider;
